module.exports = __webpack_public_path__ + "img/1893.e575dd05.png";